export default {
  startColor: '#360e59',
  startFontColor: '#ffe377',
  themeColor: '#801e91',
  // themeColor: '#007bff',
  statusBarColor: '#6a1777',
  appPrimaryColor: '#9C27B0',
  primary: '#397af8',
  primary1: '#4d86f7',
  primary2: '#6296f9',
  secondary: '#8F0CE8',
  secondary2: '#00B233',
  secondary3: '#00FF48',
  grey1: '#43484d',
  grey2: '#5e6977',
  grey3: '#86939e',
  grey4: '#bdc6cf',
  grey5: '#e1e8ee',
  dkGreyBg: '#232323',
  greyOutline: '#cbd2d9',
  white: '#ffffff',
  normalFontColor: '#000000',
  buttonColor: '#d4145a',
  aTag: '#007bff',
  // Professional accent, in the same purple/violet family the app has always used
  // (existSidebar/appPrimaryColor below) but lighter - used in place of the per-school
  // dynamic theme color in newer screens (Fees, Student view, Employee Activities tabs)
  // so the UI reads as one consistent app instead of depending on whichever school theme
  // is picked.
  accent: '#7B1FA2',
  accentDark: '#5B1584',
  // Fixed sidebar look (same values as themeList's DEFAULT_THEME) - the sidebar no longer
  // reads the per-school APP_THEME setting, so every school sees this same current design
  // regardless of what (if anything) is configured there.
  sidebarBg: '#FAF5FD',
  sidebarLabelColor: '#4A2E6B',
  sidebarActiveItemBg: '#EDE1F7',
  // Royal sidebar
  sidebar1: '#1c212d',
  sidebar1Bg: '#fed834',
  sidebar1Font: '#223820',
  existSidebar: 'rgb(98, 0, 98)', // #620062
};

// Past theme colors
// 1. #9C27B0
// 2. #7c1e8c
// 3. #360e59

// Color of sidebar changed history

/** * Line 3382 in assets/css/paper-dashboard.css  */
// #007bff (themecolor) Changed on 21-Jan-2020
// Midnightblue Changed on 9-May-2020
// Navy Changed on 11-Nov-2020
// linear-gradient(359deg, #000000, #801e91) // Changed on 5-June-2021 (Current)

// Sidebar active item bg color
/** Line 18 in Sidebar.js */
// #4caf50 (green) Changed on 21-Jan-2020
// purple changed on  5-June-2021 (Current)
